module.exports = __webpack_public_path__ + "img/chevron-up.90f47098.svg";